import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetDto } from '../../../../../../../api/src/asset/models/asset.dto';
import { ImageActionType } from '../../../../../../../api/src/asset/models/image-action.dto';
import { ImageEditorService } from '../../image-editor.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'app-image-tool-background',
	templateUrl: './image-tool-background.component.html',
	styleUrls: ['./image-tool-background.component.scss']
})
export class ImageToolBackgroundComponent implements OnInit {
	@Input() activeAsset: AssetDto;
	@Input() tools: ImageActionType[];
	@Output() setActiveAsset: EventEmitter<AssetDto> = new EventEmitter<AssetDto>();
	@Output() setActiveVariations: EventEmitter<Partial<AssetDto>[]> = new EventEmitter<Partial<AssetDto>[]>();

	public loadingAction: ImageActionType;

	public replaceBackgroundForm: UntypedFormGroup = new UntypedFormGroup({
		bg_prompt: new UntypedFormControl('')
	});

	public ImageActionType = ImageActionType;

	constructor(
		public imageEditorService: ImageEditorService
	) { }

	ngOnInit(): void {
	}

	removeBackground() {
		this.loadingAction = ImageActionType.BackgroundRemoval;

		this.imageEditorService.executeAction({
			action: ImageActionType.BackgroundRemoval,
			config: {
				asset: this.activeAsset
			}
		}).subscribe(asset => {
			this.loadingAction = null;
			this.setActiveAsset.emit(asset);
		}, error => {
			this.loadingAction = null;
			console.error('Error removing background', error);
		});
	}

	blurBackground() {
		this.loadingAction = ImageActionType.BlurBackground;

		this.imageEditorService.executeAction({
			action: ImageActionType.BlurBackground,
			config: {
				asset: this.activeAsset
			}
		}).subscribe(asset => {
			this.loadingAction = null;
			this.setActiveAsset.emit(asset);
		}, error => {
			this.loadingAction = null;
			console.error('Error blurring background', error);
		});
	}

	enhanceImage() {
		if (!this.activeAsset) {
			return;
		}

		this.loadingAction = ImageActionType.EnhanceImage;

		this.imageEditorService.executeAction({
			action: ImageActionType.EnhanceImage,
			config: {
				asset: this.activeAsset,
				visual_input_content_moderation: true,
				visual_output_content_moderation: true,
				resolution: '4MP'
			}
		}).subscribe(asset => {
			this.loadingAction = null;
			this.setActiveAsset.emit(asset);
		}, error => {
			this.loadingAction = null;
			console.error('Error enhancing image', error);
		});
	}

	replaceBackground() {
		// this.setActiveVariations.emit(
		// 	[{"assetPath":"https://bria-temp.s3.amazonaws.com/api/replace_bg_results/99266e6b64959956_A_bright_sunny_sky_0ce63d22-d786-11ee-aa8a-8e7556797829/seed_675652962.jpg?AWSAccessKeyId=ASIAUL5JH7ABLVJHCBA2&Signature=iAKwGCfYnouYhgDVOLYnl6%2F%2FIPg%3D&x-amz-security-token=FwoGZXIvYXdzED0aDINlcRVi17L3xmtRRCKYBPVm5k%2F7AjMwy%2F3wSMDLx8bsIHyfjH%2FeRUD%2Fb9BWDsd6OtAjRNXSbT5occd7%2FZIQOy5qgHdZayS%2FSd3E5sdQD5gqqr99L7Aa3geXIbvkDjOkFp2NeD%2BMy8TlipsIwVFw8dGq4HUJQ4IvuLuj4pamqt3kgUPo1rhbJyrOCxkGBmbXNvXi8l4wuYtPqudJhXDeHkJOnlPXMGWAUXszQwElpjDJMyLz9z6%2F5K9QTOKjRGyEMNt0RRWZB1yhCd2TBysimmBxw5hNaHf44WFrTZXrGbqaD3Nn6zzsyMVpvIZv0Si6zBs0kpfbhxKxOTOoWByeua%2BF%2BB7ffVjVVWl7Ux8vM8AU1nJ7vpssS46yshiRLm%2BZ36%2FQrrxTbf79rz4GYjdZPtZsWc9GWOmUMoE3aTS%2B6hcKP3bKN2C22OXuTRYdQnhwWJgm%2FS8c3rZeevXLpts5dQDgq7YwJ%2FWKOo0BgzuwpyKrsWgqioobp2HvGK6e%2Bpwb6bqnUhntI98ocShTJozVX8fxmH5EMPfSz6UgtF4qg6TObwugsDuSoNCMRQdgH1j7o0kf%2Fci2imD6SdNg3TneTUmZDW%2BaMahAHHFmFTPvWWVOZquYLh46zsbjtUlTrpDYL9yJC5hb%2FgEYe9%2BpS%2FQy9tSwESrg7Gimb2%2BOSSRrSWDhzDeXcz41DHuE1WDlaaWlzIfaqGzvSzWxD%2FEuXfKcX2UKyAaLBThlKKilha8GMir5U8wVnFiSJcVt%2BTLfWGiLrF8uof5Z1rIq3u7uH8A6qXFSoFZ%2F7U2jHdM%3D&Expires=1709872923","externalIds":{"bria_visual_id":"99266e6b64959956"}},{"assetPath":"https://bria-temp.s3.amazonaws.com/api/replace_bg_results/99266e6b64959956_A_bright_sunny_sky_0ce63d22-d786-11ee-aa8a-8e7556797829/seed_675652963.jpg?AWSAccessKeyId=ASIAUL5JH7ABLVJHCBA2&Signature=nBFXCUK8Snw9h0P27Bxo7bDauHo%3D&x-amz-security-token=FwoGZXIvYXdzED0aDINlcRVi17L3xmtRRCKYBPVm5k%2F7AjMwy%2F3wSMDLx8bsIHyfjH%2FeRUD%2Fb9BWDsd6OtAjRNXSbT5occd7%2FZIQOy5qgHdZayS%2FSd3E5sdQD5gqqr99L7Aa3geXIbvkDjOkFp2NeD%2BMy8TlipsIwVFw8dGq4HUJQ4IvuLuj4pamqt3kgUPo1rhbJyrOCxkGBmbXNvXi8l4wuYtPqudJhXDeHkJOnlPXMGWAUXszQwElpjDJMyLz9z6%2F5K9QTOKjRGyEMNt0RRWZB1yhCd2TBysimmBxw5hNaHf44WFrTZXrGbqaD3Nn6zzsyMVpvIZv0Si6zBs0kpfbhxKxOTOoWByeua%2BF%2BB7ffVjVVWl7Ux8vM8AU1nJ7vpssS46yshiRLm%2BZ36%2FQrrxTbf79rz4GYjdZPtZsWc9GWOmUMoE3aTS%2B6hcKP3bKN2C22OXuTRYdQnhwWJgm%2FS8c3rZeevXLpts5dQDgq7YwJ%2FWKOo0BgzuwpyKrsWgqioobp2HvGK6e%2Bpwb6bqnUhntI98ocShTJozVX8fxmH5EMPfSz6UgtF4qg6TObwugsDuSoNCMRQdgH1j7o0kf%2Fci2imD6SdNg3TneTUmZDW%2BaMahAHHFmFTPvWWVOZquYLh46zsbjtUlTrpDYL9yJC5hb%2FgEYe9%2BpS%2FQy9tSwESrg7Gimb2%2BOSSRrSWDhzDeXcz41DHuE1WDlaaWlzIfaqGzvSzWxD%2FEuXfKcX2UKyAaLBThlKKilha8GMir5U8wVnFiSJcVt%2BTLfWGiLrF8uof5Z1rIq3u7uH8A6qXFSoFZ%2F7U2jHdM%3D&Expires=1709872923","externalIds":{"bria_visual_id":"99266e6b64959956"}},{"assetPath":"https://bria-temp.s3.amazonaws.com/api/replace_bg_results/99266e6b64959956_A_bright_sunny_sky_0ce63d22-d786-11ee-aa8a-8e7556797829/seed_675652964.jpg?AWSAccessKeyId=ASIAUL5JH7ABLVJHCBA2&Signature=HiaH%2F2IXXD6Z%2Fpbsuzf10LQHMR8%3D&x-amz-security-token=FwoGZXIvYXdzED0aDINlcRVi17L3xmtRRCKYBPVm5k%2F7AjMwy%2F3wSMDLx8bsIHyfjH%2FeRUD%2Fb9BWDsd6OtAjRNXSbT5occd7%2FZIQOy5qgHdZayS%2FSd3E5sdQD5gqqr99L7Aa3geXIbvkDjOkFp2NeD%2BMy8TlipsIwVFw8dGq4HUJQ4IvuLuj4pamqt3kgUPo1rhbJyrOCxkGBmbXNvXi8l4wuYtPqudJhXDeHkJOnlPXMGWAUXszQwElpjDJMyLz9z6%2F5K9QTOKjRGyEMNt0RRWZB1yhCd2TBysimmBxw5hNaHf44WFrTZXrGbqaD3Nn6zzsyMVpvIZv0Si6zBs0kpfbhxKxOTOoWByeua%2BF%2BB7ffVjVVWl7Ux8vM8AU1nJ7vpssS46yshiRLm%2BZ36%2FQrrxTbf79rz4GYjdZPtZsWc9GWOmUMoE3aTS%2B6hcKP3bKN2C22OXuTRYdQnhwWJgm%2FS8c3rZeevXLpts5dQDgq7YwJ%2FWKOo0BgzuwpyKrsWgqioobp2HvGK6e%2Bpwb6bqnUhntI98ocShTJozVX8fxmH5EMPfSz6UgtF4qg6TObwugsDuSoNCMRQdgH1j7o0kf%2Fci2imD6SdNg3TneTUmZDW%2BaMahAHHFmFTPvWWVOZquYLh46zsbjtUlTrpDYL9yJC5hb%2FgEYe9%2BpS%2FQy9tSwESrg7Gimb2%2BOSSRrSWDhzDeXcz41DHuE1WDlaaWlzIfaqGzvSzWxD%2FEuXfKcX2UKyAaLBThlKKilha8GMir5U8wVnFiSJcVt%2BTLfWGiLrF8uof5Z1rIq3u7uH8A6qXFSoFZ%2F7U2jHdM%3D&Expires=1709872923","externalIds":{"bria_visual_id":"99266e6b64959956"}},{"assetPath":"https://bria-temp.s3.amazonaws.com/api/replace_bg_results/99266e6b64959956_A_bright_sunny_sky_0ce63d22-d786-11ee-aa8a-8e7556797829/seed_675652965.jpg?AWSAccessKeyId=ASIAUL5JH7ABLVJHCBA2&Signature=sICmm1Bv%2BIZ2WRTHQHsoF68i%2B94%3D&x-amz-security-token=FwoGZXIvYXdzED0aDINlcRVi17L3xmtRRCKYBPVm5k%2F7AjMwy%2F3wSMDLx8bsIHyfjH%2FeRUD%2Fb9BWDsd6OtAjRNXSbT5occd7%2FZIQOy5qgHdZayS%2FSd3E5sdQD5gqqr99L7Aa3geXIbvkDjOkFp2NeD%2BMy8TlipsIwVFw8dGq4HUJQ4IvuLuj4pamqt3kgUPo1rhbJyrOCxkGBmbXNvXi8l4wuYtPqudJhXDeHkJOnlPXMGWAUXszQwElpjDJMyLz9z6%2F5K9QTOKjRGyEMNt0RRWZB1yhCd2TBysimmBxw5hNaHf44WFrTZXrGbqaD3Nn6zzsyMVpvIZv0Si6zBs0kpfbhxKxOTOoWByeua%2BF%2BB7ffVjVVWl7Ux8vM8AU1nJ7vpssS46yshiRLm%2BZ36%2FQrrxTbf79rz4GYjdZPtZsWc9GWOmUMoE3aTS%2B6hcKP3bKN2C22OXuTRYdQnhwWJgm%2FS8c3rZeevXLpts5dQDgq7YwJ%2FWKOo0BgzuwpyKrsWgqioobp2HvGK6e%2Bpwb6bqnUhntI98ocShTJozVX8fxmH5EMPfSz6UgtF4qg6TObwugsDuSoNCMRQdgH1j7o0kf%2Fci2imD6SdNg3TneTUmZDW%2BaMahAHHFmFTPvWWVOZquYLh46zsbjtUlTrpDYL9yJC5hb%2FgEYe9%2BpS%2FQy9tSwESrg7Gimb2%2BOSSRrSWDhzDeXcz41DHuE1WDlaaWlzIfaqGzvSzWxD%2FEuXfKcX2UKyAaLBThlKKilha8GMir5U8wVnFiSJcVt%2BTLfWGiLrF8uof5Z1rIq3u7uH8A6qXFSoFZ%2F7U2jHdM%3D&Expires=1709872923","externalIds":{"bria_visual_id":"99266e6b64959956"}}]
		// );
		// return;

		this.loadingAction = ImageActionType.ReplaceBackground;

		this.imageEditorService.executeAction({
			action: ImageActionType.ReplaceBackground,
			config: {
				asset: this.activeAsset,
				...this.replaceBackgroundForm.value
			}
		}).subscribe(asset => {
			this.loadingAction = null;
			this.setActiveVariations.emit(asset);
		}, error => {
			this.loadingAction = null;
			console.error('Error replacing background', error);
		});
	}

}
